import axios from 'axios';
import config from '../config';

const apiClient = axios.create({
  baseURL: config.API_BASE_URL
});

// Add token to requests
apiClient.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const authService = {
  login: (email, password) => apiClient.post('/auth/login', { email, password }),
  register: (name, email, password) => apiClient.post('/auth/register', { name, email, password })
};

export const pageService = {
  getAllPages: () => apiClient.get('/pages'),
  getPageBySlug: (slug) => apiClient.get(`/pages/${slug}`),
  getDocuments: (pageId) => apiClient.get(`/documents/page/${pageId}`),
  getAllDocuments: () => apiClient.get('/documents/all')
};

export const announcementService = {
  getAnnouncements: () => apiClient.get('/announcements'),
  getAnnouncementById: (id) => apiClient.get(`/announcements/${id}`),
  getAllAnnouncements: () => apiClient.get('/announcements/admin'),
  createAnnouncement: (formData) => apiClient.post('/announcements', formData),
  updateAnnouncement: (id, data) => apiClient.put(`/announcements/${id}`, data),
  deleteAnnouncement: (id) => apiClient.delete(`/announcements/${id}`)
};

export const timetableService = {
  getAllTimetables: () => apiClient.get('/timetables/public'),
  createTimetable: (formData) => apiClient.post('/timetables', formData),
  deleteTimetable: (id) => apiClient.delete(`/timetables/${id}`)
};

export const resultsService = {
  getAllResults: () => apiClient.get('/results'),
  getPublicResults: () => apiClient.get('/results/public'),
  createResult: (formData) => apiClient.post('/results', formData),
  deleteResult: (id) => apiClient.delete(`/results/${id}`)
};

export const circularsService = {
  getAllCirculars: () => apiClient.get('/circulars'),
  getPublicCirculars: () => apiClient.get('/circulars/public'),
  createCircular: (formData) => apiClient.post('/circulars', formData),
  deleteCircular: (id) => apiClient.delete(`/circulars/${id}`)
};

export const adminService = {
  getPages: () => apiClient.get('/admin/pages'),
  savePage: (pageData) => {
    if (pageData instanceof FormData) {
      return apiClient.post('/admin/pages', pageData);
    }
    return apiClient.post('/admin/pages', pageData);
  },
  deletePage: (id) => apiClient.delete(`/admin/pages/${id}`),
  getDocuments: () => apiClient.get('/documents'),
  uploadDocument: (formData) => apiClient.post('/documents', formData),
  updateDocument: (id, data) => apiClient.put(`/documents/${id}`, data),
  deleteDocument: (id) => apiClient.delete(`/documents/${id}`)
};
export default apiClient;
